import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, Ref, onUnmounted, nextTick } from "vue";
import { getMatchv6 } from "@/api/php/match";
import { Match } from "@/model/Match";
import { matchListTime, matchListDay, uitlsToLiveRoom, dayToUnix } from "@/uitls/uitls";
import EventBus from "@/uitls/EventBus";
import router from "@/router";
import { Toast } from "vant";
// import { cheackQuery, nativeToNewWeb } from "@/uitls/native";
import { useRoute } from "vue-router";
import Platform from "@/config/platform";
import { useI18n } from 'vue-i18n'
// import { setTimeout } from "timers";
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'


import { Storage } from "@/uitls/Storage";
import { storeToRefs } from "pinia";
import { serverConfigPiniaState } from "@/store/serverConfig";
interface dataProps {
    nav_type: number;
    competition_id: number;
    match_type: number;
    index: number;
    name: string
}

// const listRef = ref(null);
// let nowScrollHeight: any = ref(0);
// let warpnode: any = null;


export default /*#__PURE__*/_defineComponent({
  name: 'MatchList',
  props: {
    nav_type: { type: Number, required: true },
    competition_id: { type: Number, required: true },
    match_type: { type: Number, required: true },
    index: { type: Number, required: true },
    name: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    nav_type: number;
    competition_id: number;
    match_type: number;
    index: number;
    name: string
}

//赛程列表

const ConfigpiniaStore = serverConfigPiniaState();
const { is_has_history } = storeToRefs(ConfigpiniaStore);

const { t } = useI18n()
const lanqius = require("@/assets/images/lanqius.png");
const lanqiusGif = require("@/assets/images/basketball_gif.gif");
const zuqius = require("@/assets/images/zuqius.png");
const zuqiusGif = require("@/assets/images/football_gif.gif");
// const hdgaoqing = require("@/assets/images/hdgaoqing.png");
const bofangicon = require("@/assets/images/bofang_icon.png");
const dingyue_icon = require("@/assets/images/dingyue_icon.png");
const yidingyue = require("@/assets/images/yidingyue.png");

const mach_basketball_icon = require("@/assets/images/mach_basketball_icon.png")
const mach_football_icon = require("@/assets/images/mach_football_icon.png")

const route = useRoute();
let check_id = Storage.get("check_id");
let check_type = Storage.get("check_type");

onMounted(() => {
    // cheackQuery(route);
    getData()

})

onUnmounted(() => {
    EventBus.off("matchConfirmDate")
})

// function ScrollHeigh() {
//     var top = nowScrollHeight.value
//     ,totalScroll = warpnode.scrollHeight
//     ,currentScroll = top + warpnode.offsetHeight; 
//     console.log('top',top,currentScroll,totalScroll);

//     if(top === 0) {
//         warpnode.scrollTop = 1;
//     }else if(currentScroll === totalScroll) {
//         warpnode.scrollTop = top - 1;
//     } 
// }

const dataList: Ref<any> = ref([])

const finished = ref(true); //没有更多了
const loading = ref(true);
const scrollerRef = ref(null);
let loadingMore = false;
let inited = false;
const page = ref(1)
const upPage = ref(1)
var matchConfirmDate = "";
var dayNuix = 0;
EventBus.on("matchConfirmDate", (str: string) => {
    const num = dayToUnix(str)
    dayNuix = num;


    matchConfirmDate = str;
    page.value = 1;
    upPage.value = 1;
    getData(true, true)

})
//回到今天
const jumpNowDay = ref(false);
//有没有过数据
const isData = ref(false);
const getData = async (onRefresh = false, ismatchConfirmDate = false) => {
    console.log('请求数据');

    let reqdata = {
        check_type,
        check_id,
        nav_type: props.nav_type,
        competition_id: props.competition_id,
        match_type: props.match_type,
        page: props.nav_type == 3 && onRefresh ? upPage.value : page.value,
        date: matchConfirmDate,
        limit: 20
    }

    if (ismatchConfirmDate) {
        reqdata['day_type'] = 1
    }
    if (props.nav_type == 3) {
        reqdata['day_type'] = 2
    }
    
    if (dayNuix != 0 && props.nav_type == 3) {
        reqdata['check_time'] = dayNuix
    }


    const v: any = await getMatchv6(reqdata)
    console.log(v);


    if (v.code == 200) {
        isData.value = v.data.list.length > 0 || page.value != 1;

        let dataOrb: any = {};

        v.data.list.forEach(item => {
            item['live_type'] = '2';
            if (item.host && item.host.length > 0) {
                for (let i = 0; i < item.host.length; i++) {
                    item.host[i]['live_type'] = '1';
                    item['live_type'] = '1';
                }
            }

            const matchTime = matchListDay(item.match_time, t)
            if (!dataOrb[matchTime]) {
                dataOrb[matchTime] = []
            }
            dataOrb[matchTime].push(item)
        });
        finished.value = v.data.list.length < 20;

        if (props.nav_type == 3 && onRefresh) {
            //往下拉，拿之前的数据
            dataOrb = sortObj(dataOrb)
        }
        let list = dataList.value || [];
        const shouldReplaceList = onRefresh || page.value == 1;
        if (shouldReplaceList) {
            list = [];
        }
        for (const key in dataOrb) {
            if (Object.prototype.hasOwnProperty.call(dataOrb, key)) {
                const element = dataOrb[key];
                if (element && element.length > 0) {
                    if (props.name != t('im.allin')) {
                        list.push({ id: key, key, title: true }); // 日期标题
                    }

                    list = list.concat(...element);
                }
            }
        }
        dataList.value = list;

        if (shouldReplaceList) {
            nextTick(() => {
                if (scrollerRef.value && scrollerRef.value.scrollToItem) {
                    scrollerRef.value.scrollToItem(0);
                }
            })
        }

        loading.value = false;
        loadingMore = false;
        // dayjs().
        if (page.value > 1) {
            jumpNowDay.value = true;
        }

    }

}


//obj排序
const sortObj = (obj) => {

    var arr = [];
    for (var i in obj) {
        arr.push([obj[i], i]);
    };
    let timeArray = [];
    for (let o = 0; o < arr.length; o++) {
        const element = arr[o];
        const time = element[0][0]['match_time']
        timeArray.push(time)
    }
    timeArray = timeArray.sort()
    //排序好的obj
    let timeDate = {};
    timeArray.forEach((item) => {
        const matchTime = matchListDay(item, t)
        // timeDate.push(matchTime)
        timeDate[matchTime] = null
    })

    var len = arr.length;
    var objtemp = {};
    for (var j = 0; j < len; j++) {

        objtemp[arr[j][1]] = arr[j][0];
    }
    // console.log(objtemp);
    for (const key in timeDate) {
        if (Object.prototype.hasOwnProperty.call(timeDate, key)) {
            // const element = objtemp[key];
            timeDate[key] = objtemp[key]
            timeDate[key] = timeDate[key].sort(function (a, b) {
                return a.match_time - b.match_time;
            })
        }
    }
    // console.log(timeDate);


    return timeDate;
}
const jumpNowDayFn = () => {
    // window.scroll({ top: 0, left: 0, behavior: "auto" });
    scrollerRef.value.scrollToItem(0);
    page.value = 1;
    getData(true)
    jumpNowDay.value = false;
    matchConfirmDate = "";

}

// EventBus.emit("refreshMatchData");
EventBus.on("refreshMatchData", () => {
    jumpNowDayFn()
    Toast.success(t('me.sxcg'))
    EventBus.emit("refreshSuccess");
})

const onRefresh = () => {
    page.value = 1;
    if (props.nav_type == 3) {
        upPage.value = 1;
    }
    getData(true)
};

const onLoad = (e) => {
    console.log('scroll end', e);
    if (!finished.value && !loadingMore) {
        if (inited) { // 数据初始化的时候会调用一次，加此变量避免初始化时加载数据
            page.value++;
            loadingMore = true;
            getData(false);
        }
        inited = true
    }

}

const onUpdate = (viewStartIndex, viewEndIndex, visibleStartIndex, visibleEndIndex) => {
    // console.log(`viewStartIndex=${viewStartIndex} viewEndIndex=${viewEndIndex}, visibleStartIndex=${visibleStartIndex} visibleEndIndex=${visibleEndIndex} datalist length=${dataList.value.length}`);

};

const onScrollStart = () => {
    console.log('scroll start')
}

const sersen = (item) => {
    let statusColor = "#B2B2B2";
    let status = ""
    let subStatus = Match.getStatus(item);

    let showGif = false
    if (subStatus == t("match.onlive") && subStatus !== "完场") {
        status = "正在直播";
        statusColor = "#ED3C2F";
    }

    switch (subStatus) {
        case t('match.matcherr'):
            status = subStatus;
            subStatus = ""
            break;
        case t('match.nomatch'):
            status = subStatus;
            subStatus = ""
            break;
        case t("match.matchwc"):
            status = subStatus;
            subStatus = ""
            break;
        case t("match.matchtc"):
            status = subStatus;
            subStatus = ""
            break;
        case t("match.matchzd"):
            status = subStatus;
            subStatus = ""
            break;
        case t("match.matchyz"):
            status = subStatus;
            subStatus = ""
            break;
        case t('tips.cancel'):
            status = subStatus;
            subStatus = ""
            break;
        case t('match.matchdd'):
            status = subStatus;
            subStatus = ""
            break;
        default:
            showGif = true;
            break;
    }


    return { statusColor, status, subStatus, showGif };
};

const toLiveRoom = (data) => {
    console.log('toLiveRoom', data.live_type);

    // let param = Object.assign({}, data);
    // param.live_type = '1';

    uitlsToLiveRoom(data, router)
};

const upNowBottom = () => {
    let { webclip } = route.query;
    if (webclip) {
        return "170px"
    } else if (Platform.client == 'h5') {
        return "120px"
    }
    return '50px'
}

const toDingyue = (status, item) => {
    const standalone = Platform.standalone;
    if (!standalone && Platform.client == 'h5') {
        EventBus.emit('matchAlertDownShow');
        return;
    }
    let data = {
        check_type,
        check_id,
        match_id: item.id,
        match_type: item.type_id,
        status,
    }
    window.$apiNet.get("app/encryptionFollowMatch", data).then(({ code }) => {
        console.log('code', code);
        item.is_follow = status;
        if (status) {
            Toast({
                message: t('focuSucc'),
                position: 'top',
            })
            window.$apiNet.statisticsPost({ action_id: '8' });// 统计打点
        } else {
            Toast({
                message: t('cancelFocus'),
                position: 'top',
            })
        }
        getData(false)
    })

}

const getZhishuStr = (source) => {
    if (source && source != "") {
        let arr = source.split(",");
        if (arr.length) {
            arr = arr.slice(0, 3);
            return arr.join(" ");
        }
    }
    return "";
}

const getBasketBallScore = (item) => {
    if (item.status_id > 1) {
        let arr = [t('match.xiaojie')];
        if (item.status_id >= 2) {
            arr.push(item.home_scores[0] + ":" + item.away_scores[0]);
        }
        if (item.status_id >= 4) {
            arr.push(item.home_scores[1] + ":" + item.away_scores[1]);
        }
        if (item.status_id >= 6) {
            arr.push(item.home_scores[2] + ":" + item.away_scores[2]);
        }
        if (item.status_id >= 8) {
            arr.push(item.home_scores[3] + ":" + item.away_scores[3]);
        }
        if (item.status_id >= 9) {
            arr.push(item.home_scores[4] + ":" + item.away_scores[4]);
        }

        return arr.join(" ");
    }
    return t('match.nomatch');
}


const __returned__ = { ConfigpiniaStore, is_has_history, t, lanqius, lanqiusGif, zuqius, zuqiusGif, bofangicon, dingyue_icon, yidingyue, mach_basketball_icon, mach_football_icon, route, check_id, check_type, props, dataList, finished, loading, scrollerRef, loadingMore, inited, page, upPage, matchConfirmDate, dayNuix, jumpNowDay, isData, getData, sortObj, jumpNowDayFn, onRefresh, onLoad, onUpdate, onScrollStart, sersen, toLiveRoom, upNowBottom, toDingyue, getZhishuStr, getBasketBallScore, Match, matchListTime, DynamicScroller, DynamicScrollerItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})